import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { FlamingoChangePasswordDialogComponent } from './component/flamingo-change-password-dialog.component';
import { FlamingoConfirmDialogComponent } from './component/flamingo-confirm-dialog.component';
import { FlamingoInputDialogComponent } from './component/flamingo-input-dialog.component';
import { FlamingoAuthGuard } from './service/flamingo-auth.guard';
import { FlamingoAuthService } from './service/flamingo-auth.service';
import { FlamingoErrorHandler } from './service/flamingo-error.handler';
import { FlamingoHttpInterceptor } from './service/flamingo-http.interceptor';
import { FlamingoHttpService } from './service/flamingo-http.service';
import { FlamingoMessageService } from './service/flamingo-message.service';
import { initializeFlamingo } from './service/flamingo.startup';

@NgModule({
  declarations: [
    FlamingoInputDialogComponent,
    FlamingoConfirmDialogComponent,
    FlamingoChangePasswordDialogComponent,
  ],
  imports: [
    FuseSharedModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [
    FlamingoInputDialogComponent,
    FlamingoConfirmDialogComponent,
    FlamingoChangePasswordDialogComponent,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDialogModule,
    MatButtonModule,
  ],
})
export class FlamingoModule {
  static forRoot(): ModuleWithProviders<FlamingoModule> {
    return {
      ngModule: FlamingoModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initializeFlamingo,
          multi: true,
          deps: [FlamingoHttpService],
        },
        { provide: ErrorHandler, useClass: FlamingoErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: FlamingoHttpInterceptor, multi: true },
        FlamingoAuthService,
        FlamingoHttpService,
        FlamingoMessageService,
        FlamingoAuthGuard,
      ],
    };
  }
}
